import React, { useLayoutEffect, useState } from 'react';
import { View, ScrollView, Text, Dimensions, StyleSheet } from 'react-native';
import { connect } from 'react-redux';
import { PieChart } from 'react-native-chart-kit'

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

const Component = ({ results, winloss, predict, money }) => {
    const [width, height] = useWindowSize();

    let player = 0;
    let banker = 0;
    let tie = 0;

    results.forEach(c => {
        switch(c) {
            case 'P': player ++; break;
            case 'T': tie ++; break;
            case 'B': banker ++; break;
        }
    });
    
    let pieData = [
        { name: `P (${player})`, count: player, color: 'rgb(51, 102, 255)', legendFontColor: "rgb(51, 102, 255)", legendFontSize: 12}, 
        { name: `T (${tie})`, count: tie, color: 'rgb(51, 204, 51)', legendFontColor: "rgb(51, 204, 51)", legendFontSize: 12}, 
        { name: `B (${banker})`, count: banker, color: 'rgb(255,51,0)', legendFontColor: "rgb(255,51,0)", legendFontSize: 12}, 
    ];

    if (results.length <= 0) {
        pieData = [
            { name: `รอข้อมูล`, count: 1, color: '#aaaaaa', legendFontColor: "#aaaaaa", }, 
        ];
    }

    return <View style={styles.container}>
        <View style={styles.row}>
            <View style={styles.chart}>
                <PieChart
                    data={pieData}
                    width={Math.min(1024, Dimensions.get("window").width*2/3)}
                    height={80}
                    chartConfig={{
                        decimalPlaces: 2, // optional, defaults to 2dp
                        color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
                        labelColor: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
                        style: { borderRadius: 16 },
                    }}
                    accessor="count"
                    backgroundColor="transparent"
                    paddingLeft={15}
                />
            </View>
        </View> 
    </View>
}


const mapStateToProps = state => {
    return {
        results: state.results.results,
        winloss: state.results.winloss,
        predict: state.results.predict,
        money: state.results.money,
    };
};

export default connect(mapStateToProps)(Component);
 

const styles = StyleSheet.create({
    container: {
        // flex: 0,
        maxWidth: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)'
    },
    row: {
        paddingTop: 5,
        paddingBottom: 5,
        flexDirection: "row"
    },
    chart: {
        flex: 1,
        // backgroundColor: 'rgba(0,0,0,0.7)'
    },
    right: {
        paddingRight: 10,
        flex: 0
    }
});
  
  